import { Block, Flex, IconButton, Modal, Switch } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { toggleAdjustmentSetting } from '../../redux/features/orderSlice.ts';
import { selectAdjustmentSettings } from '../../redux/features/selectors/orderSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { GuidedTourTooltip } from '../GuidedTour/GuidedTourTooltip.tsx';
import { SettingsModalContent } from './SettingsModalContent.tsx';

export function SettingsControls() {
  const dispatch = useAppDispatch();
  const adjustmentSettings = useAppSelector(selectAdjustmentSettings);

  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const modalOnOpen = () => setModalIsOpen(true);
  const modalOnClose = () => setModalIsOpen(false);
  const toggleSetting = (type: 'rounding' | 'threshold') => {
    dispatch(toggleAdjustmentSetting(type));
  };

  return (
    <Flex flexDirection="row" alignItems="center" gap=".75rem">
      <Block>
        <Switch
          id="paired-cost-rounding-enabled"
          label="Rounding"
          value={!!adjustmentSettings.enableRounding}
          onChange={() => toggleSetting('rounding')}
        />
      </Block>
      <Block>
        <Switch
          id="paired-cost-thresholds-enabled"
          label="Thresholds"
          value={!!adjustmentSettings.enableThreshold}
          onChange={() => toggleSetting('threshold')}
        />
      </Block>
      <Block>
        <GuidedTourTooltip
          text={[
            'Finally, Toolkit adjustments are based on the exact depreciated cost.  Use rounding and thresholds to format adjustments for reviewers.',
            'For example, if the sites are all similar but have small adjustments, you can remove the site adjustments by applying a threshold.',
          ]}
          tourID="analysisTour"
          tourIndex={12}
          placement="bottom"
        >
          <IconButton
            id="rounding-threshold-settings"
            size="xs"
            icon="settings-3"
            iconSize="md"
            ariaLabel="Set rounding and thresholds"
            onClick={modalOnOpen}
            variant="secondary"
          />
        </GuidedTourTooltip>
        <Modal
          title="Settings"
          isOpen={modalIsOpen}
          onClose={modalOnClose}
          size="2xl"
          showCloseButton={false} // this is the x in the top right, and it's not hooked up to saving unlike the other close button, which could be confusing so don't show it
        >
          {modalIsOpen && <SettingsModalContent modalOnClose={modalOnClose} />}
        </Modal>
      </Block>
    </Flex>
  );
}
